import styled from "styled-components";

interface SpotlightProps {
  backgroundUrl: string;
}

export const Spotlight: React.FC<SpotlightProps> = ({ ...props }) => {
  return <OuterContainer {...props}></OuterContainer>;
};

const OuterContainer = styled.div<SpotlightProps>`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 6000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${(props) => props.backgroundUrl});
  background-size: cover;
  filter: brightness(75%);
`;
